(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/containers/tickets-game-container.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/containers/tickets-game-container.js');
"use strict";


const GameContainer = svs.ticketgames.ticketScratch.containers.GameContainer;
const PlayAgain = svs.tickets.play.components.PlayAgain;
const setMainContentBg = svs.tickets.play.utils.utils.setMainContentBg;
class TicketsGameContainer extends GameContainer {
  constructor(props) {
    super(props);
    this.onPlayAgain = this.onPlayAgain.bind(this);
    this.onGameComplete = this.onGameComplete.bind(this);
    this.onGameStarted = this.onGameStarted.bind(this);
    svs.components.loader.show();
    props.ticketDispatcher.addListeners([{
      eventName: 'HAS_CLAIMED',
      handler: this.onGameComplete
    }, {
      eventName: 'GAME_LOADING',
      handler: this.onGameStarted
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: this.onGameComplete
    }], this);
  }
  onComponentWillMount() {
    const {
      ticketInfo,
      voucherCode
    } = this.props;
    setMainContentBg(ticketInfo);
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !this.props.demo) {
      let extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name,
        branding: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.icon
      };
      if (voucherCode) {
        extraParams = {
          gift: true,
          presentKod: 1
        };
      }
      svs.components.customer_login.login({
        returnNewCustomer: true,
        extraParams
      });
    }
    svs.tickets.play.utils.utils.setAnimatedBg(ticketInfo.type);
    svs.tickets.play.utils.utils.hideFooter();
  }
  onComponentWillUnmount() {
    svs.tickets.play.utils.utils.showFooter();
    svs.tickets.play.utils.utils.showHeaders(true);
    setTimeout(() => {
      this.props.appTimeline.seek('gameReady');
    }, 40);
    svs.components.loader.hide();
  }
  onGameStarted() {
    svs.components.loader.hide();
    svs.tickets.play.utils.utils.hideHeaders(true);
    svs.tickets.play.utils.utils.scrollTopContent();
  }
  onGameComplete() {
    svs.tickets.play.utils.utils.scrollTopContent();
    svs.tickets.play.utils.utils.showHeaders(true);
  }
  onPlayAgain() {
    const {
      history,
      ticketInfo
    } = this.props;
    if (svs.tickets.data.fetchedGames && svs.tickets.data.fetchedGames.length > 1) {
      window.location.href = "".concat(svs.core.data.baseUrl, "/mina-spel/pagaende");
    } else {
      svs.ticketgames.ticketScratch.utils.tracking.trackChooseNewTicket(ticketInfo.type);
      history.push("/valja/".concat(ticketInfo.type));
    }
  }
  getFooter() {
    const {
      ticketInfo,
      hasUnscratchedTicket
    } = this.props;
    return React.createElement(PlayAgain, {
      handlePlayAgain: this.onPlayAgain,
      hasUnscratchedTicket: hasUnscratchedTicket,
      ticketInfo: ticketInfo
    });
  }
}
setGlobal('svs.tickets.play.containers.TicketsGameContainer', TicketsGameContainer);

 })(window);